// extracted by mini-css-extract-plugin
module.exports = {"base":"Label_base__1vkzE","error":"Label_error__2igY2","required":"Label_required__1OOHy"};